import styled from "styled-components";

export const SeparatorContainer = styled.div `
    width: 100%;
    height: 1px;
    background-color: rgb(223,221,232, 0.5);
    margin: 5px 0;
`